export const prixConfig = {
  PackageId: '0x02fe4933f4521250e55a15441096d1d4a38a7311195b0bca126fc0138c1f5a97',
  Claim: '0x0c822cec42f7ca703696b4232f1c47b348330c23580172a29aab465bc071d894',
  turbosCoinType: '0x5d1f47ea69bb0de31c313d7acf89b890dbb8991ea8e03c6c355171f84bb1ba4a::turbos::TURBOS',
};

export const deepbookConfig = {
  PackageId: '0xdee9',
};
